import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-button',
  standalone: false,
  templateUrl: './button.component.html',
  styleUrl: './button.component.css'
})
export class ButtonComponent {
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() variant: 'primary' | 'secondary' = 'primary';
  @Input() disabled: boolean = false;
  @Input() class: string = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() noBorder: boolean = false;
  @Input() title: string = '';
  @Input() ariaLabel: string = '';

  @Output() click = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent): void {
    if (!this.disabled) {
      // Avoid duplicate parent handlers: @Output() named `click` plus bubbled native click on host.
      event.stopPropagation();
      this.click.emit(event);
    }
  }

  get buttonClasses(): string {
    const baseClasses = 'inline-flex items-center justify-center font-semibold transition-all duration-200 focus:outline-none disabled:opacity-60 disabled:cursor-not-allowed rounded-md shadow-sm';
    
    const sizeClasses = {
      sm: 'px-3 py-1.5 text-xs',
      md: 'px-4 py-2 text-sm',
      lg: 'px-6 py-3 text-base'
    };

    const borderClass = this.noBorder ? 'border-0' : 'border border-[var(--primary)]';
    const variantClasses = {
      primary: `bg-[var(--primary)] text-white hover:bg-white hover:text-[var(--primary)] ${borderClass} hover:shadow-md`,
      secondary: `bg-white text-[var(--primary)] hover:bg-[var(--primary)] hover:text-white ${borderClass} hover:shadow-md`
    };

    return `${baseClasses} ${sizeClasses[this.size]} ${variantClasses[this.variant]} ${this.class}`;
  }
}
